<template>
  <div>
    <NumberDisplay />
    <DialpadContainer />
  </div>
</template>

<script>
import NumberDisplay from './NumberDisplay'
import DialpadContainer from './DialpadContainer'

export default {
  components: {
    NumberDisplay,
    DialpadContainer
  }
}
</script>



// WEBPACK FOOTER //
// DialpadMode.vue?78d6bd20